import { nextTick } from 'vue'
import { messageSender } from '@/enum'
import type { AppMessage } from '@/types/Message'

const SCROLL_PADDING = 12 // Gap between messages

export async function scrollToLastUserMessage (messages: AppMessage[]): Promise<void> {
  if (messages.length === 0) {
    return
  }

  await nextTick()

  const chatMessages = document.getElementById('chat-messages')
  if (!chatMessages) {
    return
  }

  const messageSheets = chatMessages.querySelectorAll('.message-sheet')
  if (messageSheets.length === 0) return

  const lastUserMessageIndex = messages.findLastIndex(
    msg => msg.sender === messageSender.USER
  )

  if (lastUserMessageIndex === -1) {
    scrollToBottom(chatMessages)
    return
  }

  const targetElement = messageSheets[lastUserMessageIndex] as HTMLElement | undefined

  if (!targetElement) {
    return
  }

  scrollToElement(chatMessages, targetElement, SCROLL_PADDING)
}

export async function scrollToMessagesBottom (): Promise<void> {
  await nextTick()

  const chatMessages = document.getElementById('chat-messages')
  if (!chatMessages) {
    return
  }

  scrollToBottom(chatMessages)
}

function scrollToBottom (container: HTMLElement): void {
  const scrollTop = container.scrollHeight

  if ('scrollBehavior' in document.documentElement.style) {
    container.scrollTo({ top: scrollTop, behavior: 'smooth' })
    return
  }

  container.scrollTop = scrollTop
}

function scrollToElement (
  container: HTMLElement,
  element: HTMLElement,
  padding: number
): void {
  const messageRect = element.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()
  const scrollTop = messageRect.top - containerRect.top + container.scrollTop - padding

  if ('scrollBehavior' in document.documentElement.style) {
    container.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    })
    return
  }

  container.scrollTop = scrollTop
}
